<template>
  <div
    v-if="!isPreview && preNextOptions.isDefaultPost == 0"
    class="flex w-full items-center justify-end mb-2 mt-4"
  >
    <div class="w-1/2">
      <button
        @click="prePost()"
        class="text-sm bg-white text-pink-button border border-gray-500 hover:border-gray-500 focus:outline-none hover:bg-pink hover:text-white font-semibold py-1 rounded w-full px-2 h-10"
        :class="preNextOptions.isMarkComplete ? '' : ''"
      >
        {{ $t('frontend_groovemember_main_panel_previous_button') }}
      </button>
    </div>
    <div class="w-1/2 ml-1">
      <button
        @click="nextPost()"
        style="padding: 5px 10px"
        class="text-sm bg-white border border-gray-500 hover:outline-none focus:outline-none hover:bg-pink hover:text-white font-semibold rounded w-full h-10"
        :class="
          preNextOptions.isMarkComplete
            ? 'bg-pink-mark-complete text-white border-pink-500'
            : 'bg-white text-pink-button'
        "
      >
      {{ $t('frontend_groovemember_main_panel_next_button') }}
      </button>
    </div>
  </div>
</template>
<script>
import PrevNextButton from './prev-next-button';
export default {
  name: 'PrevNextButton',
  props: ['isPreview', 'preNextOptions'],
  methods: {
    nextPost() {
      this.preNextOptions.nextPostMethod();
    },
    prePost() {
      this.preNextOptions.prevPostMethod();
    },
  },
};
</script>
<style>
.bg-pink-mark-complete {
  background-color: #fd6481;
}
.text-pink-button {
  color: #fd6481;
}
</style>